export enum AccessLevelModel {
  NONE = 'NONE',
  READ = 'READ',
  EDIT = 'EDIT',
}

/** The order of the access levels, for sorting users by their access. */
export type AccessWeight = Record<AccessLevelModel, number>;

export function hasNoIssueAccess(accessLevel: AccessLevelModel | undefined): boolean {
  return accessLevel === undefined || accessLevel === AccessLevelModel.NONE;
}
